import type { RouteRecordRaw } from 'vue-router'

/*
  Not fully migrated, this is here to support the footer migration.
  Please check and migrate correctly
*/

export const STUDENT_DISCOUNT = 'student_discount'

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/student-discount',
    name: STUDENT_DISCOUNT,
    component: () => import('./StudentDiscount.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
